// @flow
import {
    CLEAR_RESET_PASSWORD_ERROR,
    FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT,
    FORGOTTEN_PASSWORD_READY,
    FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST,
    PASSWORD_RESET_REQUEST,
    RESET_PASSWORD,
    RESET_PASSWORD_READY,
    RESETTING_PASSWORD
} from './constants';

import { createAction } from 'redux-actions';

export const initialiseResetPasswordState = createAction(RESET_PASSWORD_READY);
export const initialiseForgottenPasswordState = createAction(FORGOTTEN_PASSWORD_READY);
export const sendPasswordResetEmail = createAction(FORGOTTEN_PASSWORD_SENDING_EMAIL_REQUEST);
export const passwordEmailRequestSent = createAction(FORGOTTEN_PASSWORD_EMAIL_REQUEST_SENT);
export const resetPassword = createAction(RESET_PASSWORD);
export const clearResetPasswordError = createAction(CLEAR_RESET_PASSWORD_ERROR);

export const changePassword = createAction(RESETTING_PASSWORD, (newPassword, existingPassword, userId) => ({
    newPassword,
    existingPassword,
    userId
}));

export const passwordResetRequest = createAction(PASSWORD_RESET_REQUEST, (password, token, email) => ({
    password,
    token,
    email
}));



// WEBPACK FOOTER //
// ./src/core/state/authentication/actions.js